import { useContext, useEffect, useState } from 'react';
import { GlobalContext } from '../../../shared/GlobalContext/GlobalContext';
import SSOConf from '../../../../modules/constants/SSOConf';

export default function useGoogleClassroomLoginButton({
  redirectTo,
  redirectErrorTo,
  isStudent,
  stateParams,
}) {
  const [state, setState] = useState({});
  const context = useContext(GlobalContext);
  useEffect(() => {
    const loginUrl = SSOConf.google.getLoginUrl({
      user: context.state.user,
      redirectTo,
      redirectErrorTo,
      isStudent,
      stateParams,
    });
    setState({ loginUrl });
  }, [context, redirectTo, stateParams]);
  return { state };
}
